import { ApiService } from 'Administrator_Helpers/ApiService';

export class NotificationApiDataService {
  private static _instance: NotificationApiDataService = new NotificationApiDataService();
  private api: ApiService;

  constructor() {
    // Make sure we don't create more than one instance of this service
    if (NotificationApiDataService._instance) {
      return NotificationApiDataService._instance;
    }
    this.api = new ApiService();
  }

  public sendNotificationToUsers = async (request: {
    UserIds: number[];
    BypassScheduleRules: boolean;
    Title: string;
    Message: string;
    NotificationMethodId: number;
  }) => {
    const { response, error, success } = await this.api.post('/v1/notification-requests/user', null, request);
    return { response, error, success };
  };
}

